import { useCallback, useEffect, useState } from 'react';
import { getFullAssessmentData } from '../../../../../../services/data-entry/assessments.service';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import FilterDialog from './Dialog';
import { useSelector } from 'react-redux';
import FilterButton from '../../../../../filter/FilterButton';

const FilterButtonAssessmentMarking = () => {
  const open = useSelector((state) => state?.filter?.assessmentMarking?.open || false);
  const userId = useSelector((state) => state?.session?.user?.userId || '');
  const permission = useSelector((state) => state?.session?.permissions?.class?.list || {});
  const { assessmentId } = useParams();
  const [loading, setLoading] = useState(false);
  const [classesOptions, setClassesOptions] = useState([]);
  const [yearLevelsOptions, setYearLevelsOptions] = useState([]);
  const [showFilters, setShowFilters] = useState({
    classes: true,
    yearLevel: true
  });
  const { enqueueSnackbar } = useSnackbar();

  const onLoadAssessmentData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getFullAssessmentData(assessmentId);

      if (!response?.data && response?.error) {
        enqueueSnackbar(response.error.message || 'An error ocurred', {
          variant: 'error'
        });
      } else {
        let filters = {
          classes: true,
          yearLevel: true
        };
        const resp = response?.data;
        let classesData = resp?.classes || [];

        let studentsYearLevels = [];

        resp?.students?.forEach((element) => {
          studentsYearLevels = [...studentsYearLevels, ...(element?.yearlevel || [])];
        });

        const uniqueYearLevels =
          Array.from(new Map(studentsYearLevels?.map((item) => [item?._id, item])).values())?.map((el) => ({
            ...el,
            shortName: el?.shortName || el?.name
          })) || [];

        if (resp?.type === 'custom') {
          filters.classes = false;
        } else {
          const hasAllPermissions = permission.some((item) => item === 'all');
          const isTeacher = permission.some((item) => item === 'by-teacher');
          if (!hasAllPermissions && isTeacher) {
            classesData = classesData.filter(
              (item) =>
                item?.teachers?.some((teacher) => teacher === userId) ||
                item?.reviewers?.some((reviewer) => reviewer._id === userId)
            );
          }
        }

        setClassesOptions(classesData);
        setYearLevelsOptions(uniqueYearLevels);
        setShowFilters(filters);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [assessmentId]);

  useEffect(() => {
    onLoadAssessmentData();
  }, []);

  return (
    <>
      <FilterButton
        module='assessmentMarking'
        keysFilter={['yearLevelId', 'classesCode']}
        keepReload={false}
      />
      {open && (
        <FilterDialog
          showFilters={showFilters}
          dataClasses={classesOptions}
          dataYears={yearLevelsOptions}
          isLoadingClasses={loading}
          isLoadingYears={loading}
        />
      )}
    </>
  );
};
export default FilterButtonAssessmentMarking;
